import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import AppContext from "../../context/AppContext";
import { toast } from "react-toastify";
import {
  updateProfileInfo,
  getUserInfo,
  updateProfilePicture,
} from "../../service/User";
import dummyImg from "../../assets/dummy.webp";
import { deleteS3Object, uploadFileToS3 } from "../../service/S3Bucket";
import { Spinner } from "../../Spinner";
import translations from "../../components/common/Translations";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { HiOutlineArrowLongLeft } from "react-icons/hi2";
import CommonButton from "../../components/common/CommonButton";

const ProfileSection = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { profilePic, setProfilePic, langMode } = useContext(AppContext);
  const [userInfo, setUserInfo] = useState(null);
  const [initialUserInfo, setInitialUserInfo] = useState(null);
  const { theme } = useContext(AppContext);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isPasswordCleared, setIsPasswordCleared] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('')
  const [selectedFile, setSelectedFile] = useState('')
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  useEffect(() => {
    const profilePic = Cookies.get("profilePic");
    if (profilePic && profilePic !== "null") {
      setProfilePic(profilePic);
    } else {
      setProfilePic(dummyImg);
    }
  }, []);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  async function deleteExistingImage() {
    const oldPic = Cookies.get("profilePic");
    if (!oldPic || oldPic === "null") return; // No image to delete

    try {
      const urlParts = oldPic.split('/');
      const oldKey = urlParts.slice(3).join('/'); // Extracts key from S3 URL
      console.log("Deleting S3 object with key:", oldKey);

      await deleteS3Object({ Key: oldKey }); // Pass as object with Key property
    } catch (error) {
      console.error("Error deleting existing S3 image:", error);
    }
  }

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];

    if (!file || !allowedTypes.includes(file.type)) {
      toast.error(translations[langMode].invalidfiletype);
      return;
    }
    setUploadedImg(URL.createObjectURL(file));
    setSelectedFile(file); // Store file for later upload
  };

  const navigate = useNavigate();
  const ChangePassword = () => {
    if (userInfo?.email) {
      navigate("/reset-password", {
        state: { emaill: userInfo.email, fromProfile: true },
      });
    } else {
      toast.error(translations[langMode].emailnotavailble);
    }
  };
  useEffect(() => {
    GetUserInfo();
  }, []);

  const GetUserInfo = async () => {
    setLoading(true);
    try {
      const data = await getUserInfo();
      setUserInfo(data);
      setInitialUserInfo(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };

  const handleFieldChange = (e) => {
    if (!userInfo) return;

    const { name, value } = e.target;

    if (name === "password") {
      if (!isPasswordCleared && value !== "") {
        toast.error(translations[langMode].youcanotmodify);
        return;
      }

      if (!isPasswordCleared && value === "") {
        toast.success(translations[langMode].youcanowenter);
        setIsPasswordCleared(true);
        setUserInfo((prevUserInfo) => ({
          ...prevUserInfo,
          password: "",
        }));
        return;
      }
    }

    setUserInfo((prevUserInfo) => ({
      ...prevUserInfo,
      [name]: value,
    }));
  };

  const handleCancle = () => {
    const path = Cookies.get('previousPath')
    navigate(path);
  };

  const handleSaveChanges = async () => {
    if (selectedFile) {
      const uploadedPhotoUrl = await uploadFileToS3(selectedFile);
      if (!uploadedPhotoUrl) {
        throw new Error("Upload failed or returned empty URL");
      }
      setProfilePic(uploadedPhotoUrl);
      await updateProfilePicture(uploadedPhotoUrl);
    }

    if (isPasswordCleared && !validatePassword(userInfo.password)) {
      toast.error(translations[langMode].passowrdmust);
      return
    }
    try {
      await updateProfileInfo(
        userInfo.userId,
        userInfo.name,
        userInfo.email,
        userInfo.phone,
        userInfo.password,
        isPasswordCleared,
      );
      sessionStorage.setItem("userDetails", JSON.stringify(userInfo));
      Cookies.set("userType", userInfo.userType, {
        secure: true,
        sameSite: "strict",
      });
      Cookies.set("userId", userInfo.userId);
      Cookies.set("userName", userInfo.name);
      Cookies.set("userVisibility", userInfo.userVisibility);
      Cookies.set("userEmail", userInfo.email, { httpOnly: true });
      GetUserInfo();
      toast.success(translations[langMode].profileupdated);
    } catch (error) { }
  };

  const handleGoBack = () => {
    const path = Cookies.get('previousPath')
    navigate(path);
  };
  return (
    <div className="w-full">
      {loading && <Spinner />}

      <div className='flex items-center gap-2 ml-4'>
        <button
          onClick={handleGoBack}
          className="
                 p-1
                 bg-blue-100
                 text-blue-800
                 rounded-full
                 shadow-md
                 hover:bg-blue-200
                 focus:outline-none
                 focus:ring-2
                 focus:ring-blue-400
                 focus:ring-opacity-75
                 transition
                 duration-200
                 ease-in-out
                 flex items-center justify-center
                 min-h-[36px] h-9 w-9
                 "
          aria-label="Go back"
        >
          <HiOutlineArrowLongLeft size={24} />
        </button>
        <p className='uppercase font-semibold'> {translations[langMode].profile}</p>
      </div>

      <div
        className={`px-5 py-5 mt-2 bg-white ${theme === "dark"
          ? "dark-mode"
          : theme === "high-contrast"
            ? "high-contrast"
            : ""
          } `}
      >
        <div className="w-1/2">
          <div className="mb-5">
            <img
              key={profilePic}
              className={`w-20 h-20 p-1 rounded-full border-2 border-gray-400 my-2 ml-2 ${theme === "dark"
                ? "bg-white"
                : theme === "high-contrast"
                  ? "bg-white"
                  : ""
                }`}
              src={uploadedImg ? uploadedImg : profilePic}
              alt="profileimg"
            />
            <span
              className="text-sm text-blue-700 font-semibold underline cursor-pointer"
              onClick={triggerFileInput}
            >
              <p className="">{translations[langMode].changeprofile}</p>
            </span>
            <input
              type="file"
              name="media"
              onChange={handleImageUpload}
              accept="image/jpeg, image/png, image/gif, image/jpg"
              className="uploadFile hidden"
              ref={fileInputRef}
            />
          </div>
          <h3 className="text-sm text-gray-500 font-bold">{translations[langMode].basicinfo}</h3>
          <div className=" mt-5 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-4">
            <div className="sm:col-span-2">
              <div className="relative">
                <label
                  className="text-sm"
                >
                  {translations[langMode].username}
                </label>
                <input
                  type="text"
                  value={userInfo && userInfo.name}
                  onChange={handleFieldChange}
                  name="name"
                  className={`block p-3 w-full text-sm text-gray-900 bg-transparent rounded-md border-1 border-[#D1D5DB]
                                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                />
              </div>
            </div>
            <div className="sm:col-span-2">
              <div className="relative">
                <label
                  className="text-sm"
                >
                  {translations[langMode].userType}
                </label>
                <input
                  type="text"
                  value={userInfo && userInfo.userType}
                  name="userType"
                  className={`block bg-gray-50 p-3 w-full read-only cursor-none text-sm text-gray-900 bg-transparent rounded-md border-1 border-[#D1D5DB]
                                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                />
              </div>

            </div>
            <div className="sm:col-span-2">
              <div className="relative">
                <label
                  className="text-sm"
                >
                  {translations[langMode].Email}
                </label>
                <input
                  type="text"
                  value={userInfo && userInfo.email}
                  onChange={handleFieldChange}
                  name="email"
                  className={`block p-3 w-full text-sm text-gray-900 bg-transparent rounded-md border-1 border-[#D1D5DB]
                                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                />
              </div>
            </div>
            <div className="sm:col-span-2">
              <div className="relative">
                <label
                  className="text-sm"
                >
                  {translations[langMode].Phone}
                </label>
                <input
                  type="text"
                  value={userInfo && userInfo.phone}
                  onChange={handleFieldChange}
                  name="phone"
                  className={`block p-3 w-full text-sm text-gray-900 bg-transparent rounded-md border-1 border-[#D1D5DB]
                                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                />
              </div>
            </div>
            <div className="sm:col-span-2">
              <div className="relative">
                <label
                  className="text-sm"
                >
                  {translations[langMode].UserId}
                </label>
                <input
                  type="text"
                  value={userInfo && userInfo.userId}
                  name="userId"
                  className={`block p-3 w-full text-sm text-gray-900 bg-transparent rounded-md border-1 border-[#D1D5DB]
                                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                />
              </div>

            </div>
            <div className="sm:col-span-2">

              <div className="relative">
                <label
                  className="text-sm"
                >
                  {translations[langMode].password}
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  value={userInfo && userInfo?.password}
                  onChange={handleFieldChange}
                  name="password"

                  className={`block p-3 w-full text-sm text-gray-900 bg-transparent rounded-md border-1 border-[#D1D5DB]
                                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""
                    }`}
                />

                <button
                  type="button"
                  disabled={!isPasswordCleared}
                  className="absolute inset-y-0 right-3 top-6 flex items-center text-gray-600"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10">
          <div className="sm:col-span-4">
            <hr className="w-full border-gray-300" />
          </div>
          <div className="sm:col-span-4 pt-5 flex justify-end gap-5 items-center">
            <CommonButton
              type="button"
              onClick={handleCancle}
              variant="danger"
              tooltipText= {translations[langMode].cancelanddiscardchanges}
              tooltipPosition="top"
            >
              {translations[langMode].cancel}
            </CommonButton>
            <CommonButton
              type="button"
              onClick={handleSaveChanges}
              variant="primary"
              tooltipText={translations[langMode].savechangesforprofile}
              tooltipPosition="top"
            >
              {translations[langMode].save}
            </CommonButton>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProfileSection;
